export default "https://cdn-static.gokick.com/assets/1c04a0e7cb9e690604c984af7e1d0f36647cf8e0/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";